import { Cloud, CloudRain, Droplets, Snowflake, Sun, Wind } from "lucide-react";
import type { WeatherBand, WeatherCondition } from "@/lib/weather";

function pickIcon(condition: WeatherCondition | null, band: WeatherBand | null) {
  if (condition === "clear") return Sun;
  if (condition === "clouds") return Cloud;
  if (condition === "rain") return CloudRain;
  if (condition === "snow") return Snowflake;
  if (condition === "wind") return Wind;
  if (condition === "humid") return Droplets;
  if (band === "hot" || band === "warm") return Sun;
  if (band === "cold") return Snowflake;
  return Cloud;
}

function cap(s: string) {
  return s.charAt(0).toUpperCase() + s.slice(1);
}

export function WeatherIndicator({
  condition,
  band,
  size = 18,
}: {
  condition: WeatherCondition | null;
  band: WeatherBand | null;
  size?: number;
}) {
  if (!condition && !band) return null;
  const Icon = pickIcon(condition, band);
  const label = [band ? cap(band) : null, condition ? cap(condition) : null]
    .filter(Boolean)
    .join(" · ");
  return (
    <span style={{ display: "inline-flex", alignItems: "center", gap: 8 }}>
      <Icon size={size} color="var(--caileve-muted)" strokeWidth={1.5} />
      <span
        style={{
          fontSize: 11,
          color: "var(--caileve-muted)",
          textTransform: "uppercase",
          letterSpacing: "0.25em",
        }}
      >
        {label}
      </span>
    </span>
  );
}